/**
 * ข้อมูลตัวละคร: สายพันธุ์และชุดสี
 * โมเดล 3 มิติจริงปั้นจากข้อมูลนี้ใน scene3d/critters3d.ts
 */

export type Species = 'cat' | 'dog' | 'panda' | 'bunny' | 'fox' | 'frog' | 'penguin' | 'owl'

export interface CritterSpec {
  species: Species
  /** สีขน */
  fur: string
  /** สีเข้มสำหรับหู/ลาย */
  dark: string
  /** สีท้อง/หน้า */
  belly: string
}

export const CRITTERS: Record<string, CritterSpec> = {
  millo: { species: 'cat', fur: '#ffb454', dark: '#e8912a', belly: '#fff0d6' },
  budgie: { species: 'dog', fur: '#7fc4ff', dark: '#4a9ae0', belly: '#e8f5ff' },
  porto: { species: 'panda', fur: '#f2f5fa', dark: '#2f3947', belly: '#ffffff' },
  richie: { species: 'bunny', fur: '#ff9ec4', dark: '#e8639b', belly: '#ffe8f2' },
  finn: { species: 'fox', fur: '#ff8a5c', dark: '#d95f30', belly: '#fff2e8' },
  kevin: { species: 'frog', fur: '#8ee06a', dark: '#5cb83c', belly: '#e8ffd9' },
  pete: { species: 'penguin', fur: '#3d4a63', dark: '#232c3d', belly: '#ffffff' },
  warren: { species: 'owl', fur: '#d9b97a', dark: '#a8873f', belly: '#fff6e0' },
}
